const Stick = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 13 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.914424 0.573126C0.914424 0.573126 0.893492 0.44086 0.883025 0.374727C0.872559 0.308594 1.00482 0.287661 1.07096 0.277194L11.5623 0.175952C11.7607 0.144553 11.8478 0.266352 12.001 0.377685C12.088 0.499485 12.1751 0.621285 12.2726 0.809217C12.2726 0.809217 12.2936 0.941483 12.2379 1.01808C12.1718 1.02855 12.1161 1.10515 12.0395 1.04948L1.54815 1.15072C1.41589 1.17166 1.26269 1.06032 1.17562 0.938524C1.08856 0.816725 1.00149 0.694926 0.914424 0.573126Z"
        fill="currentColor"
      />
    </svg>
  )
}

Stick.displayName = 'Stick'

export default Stick
